export default "/images/contentAffinity.svg?34d8ac65b0d86cbfaf85ed50b77b2a4b";